<template>
  <div class="row shaded thank-you">
    <div class="columns medium-12 text text-center">
      <header class="text-center">
        <h2 class="qes-thank-you-title">Thank You for Joining!</h2>
      </header>
      <p class="text-center">
        We hope you enjoy exploring our wines. Have any questions or problems?
        We can help! Speak with our Member Services team at
        <a href="mailto:help@wineaccess.com">help@wineaccess.com</a>.
      </p>
    </div>
  </div>
</template>

<style scoped>
.qes-thank-you-title {
  text-align: center !important;
}
</style>
